import { render, staticRenderFns } from "./ReorderParamForm.vue?vue&type=template&id=b70b8b76&scoped=true"
import script from "./ReorderParamForm.vue?vue&type=script&lang=ts"
export * from "./ReorderParamForm.vue?vue&type=script&lang=ts"
import style0 from "./ReorderParamForm.vue?vue&type=style&index=0&id=b70b8b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70b8b76",
  null
  
)

export default component.exports